import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FactoryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"factory"}/>
}
